import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/router";

import { getWarehouseTransferNote, transferNoteIdString } from "../../core/warehouseTransferNote.core";
import useGetRetailShopId from "../useGetRetailShopId.hook";

export function useWarehouseTransferNoteDetail() {
  const router = useRouter();
  const rawId = typeof router.query.id === "string" ? router.query.id : "";
  const retailId = useGetRetailShopId();

  const query = useQuery({
    enabled: !!rawId && !!retailId,
    queryKey: ["warehouseTransferNote", rawId, retailId],
    queryFn: () => getWarehouseTransferNote(rawId),
  });

  const note = query.data;
  const isOutgoing = note ? transferNoteIdString(note.fromRetailShopId) === retailId : false;
  const isIncoming = note ? transferNoteIdString(note.toRetailShopId) === retailId : false;
  const editable = note?.status === "draft" || note?.status === "submitted";
  const showLineEditor = isOutgoing && editable;

  return {
    ...query,
    rawId,
    retailId,
    note,
    isOutgoing,
    isIncoming,
    editable,
    showLineEditor,
  };
}
